'use strict';

module.exports = tpsv;

function tpsv () {
  console.error('TPSV (triangular packed matrix solver) not yet implemented');
}
